/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type S3MediaType = 'Image' | 'Video' | 'Pdf';

export const S3MediaType = {
    Image: 'Image' as S3MediaType,
    Video: 'Video' as S3MediaType,
    Pdf: 'Pdf' as S3MediaType
};

